/**
 * implementation of <BattleModeFilter /> for battle rooms list
 * @see https://confluence.wargaming.net/display/WEBDEV/%5BLeg%5D+UI+Legionaries+draft
 */


import { connect } from 'react-redux'

import { filterUnitsByLevelAndUnitType } from 'state/actions/available_units'

import { BATTLE_ROOMS_TAB_STATES } from 'constants'

import { BattleModeFilter } from '../BattleModeFilter'
import { sortBattleModeSettings } from '../helpers'

export const mapStateToProps = ({ availableUnits }) => ({
    tab: BATTLE_ROOMS_TAB_STATES.UNITS,
    selectedUnitType: availableUnits.filter.unitType,
    selectedVehicleLevel: availableUnits.filter.level,

    battleModesSettings: sortBattleModeSettings(availableUnits.meta.battle_modes_settings),
})

const mapDispatchToProps = {
    onChange: (unit_type, vehicle_level) => filterUnitsByLevelAndUnitType(unit_type, vehicle_level),
}

export default connect(mapStateToProps, mapDispatchToProps)(BattleModeFilter)



// WEBPACK FOOTER //
// ./containers/BattleRooms/components/BattleModeFilter/containers/BattleRoomsListFilter.jsx